import {Navigate, useRoutes} from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard/DashboardLayout";
import SimpleLayout from "./layouts/simple/SimpleLayout";
// pages
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import UserRoles from "./components/UserRoles";
import Products from "./components/Products";
import RoleUsers from "./components/RoleUsers";
import UserProducts from "./components/UserProducts";
import Features from "./components/Features";
import SaleTax from "./pages/SaleTax/SaleTax";
import AddressValidation from "./pages/AddressValidation/AddressValidation";
import ManageProducts from "./components/ManageProducts";
import Page404 from "./components/Page404";
import {useCheckAuthToken} from "./hooks/useCheckAuthToken";
import {PrivateRoute} from "./util/PrivateRoutes/PrivateRoutes";
import PublicRoute from "./util/PublicRoute";
import ForgotPasswordPage from "./components/ForgotPassword/ForgotPasswordPage";
import ResetPasswordPage from "./components/ForgotPassword/ResetPasswordPage";
import {GenericEmailLogin} from "./components/GenericEmailLogin/GenericEmailLogin";
import {GenericClassicLogin} from "./components/GenericClassicLogin/GenericClassicLogin";
import {OtpRequestPage} from "./components/CuustomerPortal/OtpRequestPage/OtpRequestPage";
import {OtpVerificationPage} from "./components/CuustomerPortal/OtpVerificationPage/OtpVerificationPage";
import SubscriptionsPage from "./target-manager/Subscriptions/SubscriptionsPage";
import Layout from "./target-manager/Layout";
import ProductsPage from "./target-manager/Products/ProductsPage";
import DealersPage from "./target-manager/Dealers/DealersPage";
import FeaturesPage from "./target-manager/Features/FeaturesPage";
import DashboardPage from "./target-manager/Dashboard/DashboardPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    //* Dashboard Layout
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        {element: <Navigate to="/login" />, index: true},
        {
          path: "app",
          element: (
            <PrivateRoute
              element={<Dashboard />}
              isAuthenticated={useCheckAuthToken}
            />
          ),
        },
        {
          path: "user/:userId/roles",
          element: <UserRoles />,
        },
        {
          path: "user/:userId/products",
          element: <UserProducts />,
        },
        {
          path: "products",
          element: <Products />,
        },
        {
          path: "tm-dashboard",
          element: <DashboardPage />,
        },
        {
          path: "role/:roleId/users",
          element: <RoleUsers />,
        },
        {
          path: "features",
          element: <Features />,
        },
        {
          path: "manage-products",
          element: <ManageProducts />,
        },
      ],
    },

    //* Simple Layout
    {
      element: <SimpleLayout />,
      children: [
        {element: <Navigate to="/login" />, index: true}, // Default to login
        {
          path: "login",
          element: <PublicRoute element={<Login />} />, // Use PublicRoute for login
        },
        {
          path: "forgot-password",
          element: <PublicRoute element={<ForgotPasswordPage />} />,
        },
        {
          path: "reset-password",
          element: <ResetPasswordPage />,
        },
        {path: "404", element: <Page404 />},
      ],
    },

    //*Target Manager Layout
    {
      element: <Layout />,
      children: [
        {element: <Navigate to="/tm-dashboard" />, index: true},
        {path: "tm-dashboard", element: <DashboardPage />},
        {path: "subscriptions", element: <SubscriptionsPage />},
        {path: "features", element: <FeaturesPage />},
        {path: "products", element: <ProductsPage />},
        {path: "dealers", element: <DealersPage />},
      ],
    },
    //* No Layout
    {
      path: "classic-login",
      element: <GenericClassicLogin />,
    },
    {
      path: "email-login",
      element: <GenericEmailLogin />,
    },
    {
      path: "otp-request",
      element: <OtpRequestPage />,
    },
    {
      path: "otp-verification",
      element: <OtpVerificationPage />,
    },
    {
      path: "sale-tax",
      element: <SaleTax />,
    },
    {
      path: "address-validation",
      element: <AddressValidation />,
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
